export const refs = {
  // назва елементу: document.querySelector("селектор"),
  // назва елементу: document.querySelector("селектор"),
  body: document.querySelector('body'),
  movieCard: document.querySelector('.card'),
  galleryBox: document.querySelector('.gallery'),
  modalMovie: document.querySelector('.modal__card'),
  backdrop: document.querySelector('.backdrop'),
  modalClose: document.querySelector('.modal__button--close'),
};
// Вставляйте, якщо потрібно, цей файл у свій JS код та отримуйте посилання
// на потрібний елемент за допомогою - refs.назва елементу
